import { useContext, useState } from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import useStyles from "./styles";
import endoso from "services/endoso";
import { TraditionalSave, UploadExcel } from "./components";
import { AltaContext } from "../../../context";
import { AuthContext } from "context/context";

export const AltaRiesgo16 = () => {
  const classes = useStyles();
  const { setTimer } = useContext(AuthContext);
  const { selected, setSelected } = useContext(AltaContext);
  const [disabled, setDisabled] = useState(false);
  const returntoMain = () => setSelected(undefined);
  if (selected === "tradicional") return <TraditionalSave />;

  if (selected === "archivo")
    return <UploadExcel returntoMain={returntoMain} />;

  const activate = () => setDisabled(false);
  const download = () => {
    setTimer(0);
    setDisabled(true);
    endoso.descargarLayout(activate);
  };

  return (
    <div>
      <Typography variant="h6">
        ¿Cómo desea agregar los nuevos asegurados?
      </Typography>
      <Grid container spacing={2} className={classes.container}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => setSelected("tradicional")}
          >
            Agregar de manera tradicional
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => setSelected("archivo")}
          >
            Agregar por archivo de asegurados
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={download}
            disabled={disabled}
          >
            Descargar Plantilla de Layout
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
